import { Box, Avatar, Stack, Typography } from '@mui/material'
import TableData from '../../atoms/table/TableData'
import ButtonCustom from '../../atoms/button/ButtonCustom'

export default function UpcomingWeddingsTable({ rows = [] }) {
	const columns = [
		{
			field: 'weddingName',
			headerName: 'Wedding Name',
			flex: 2,
			minWidth: 200,
			renderCell: (params) => (
				<Stack direction="row" alignItems="center" spacing={1}>
					<Avatar
						src={params.row.avatar}
						alt={params.row.Couple}
						sx={{ width: 32, height: 32 }}
					/>
					<Typography
						variant="body2"
						fontWeight={500}
						color="text.primary"
					>
						{params.row.Couple}
					</Typography>
				</Stack>
			),
		},
		{
			field: 'Date',
			headerName: 'Date',
			flex: 1,
			minWidth: 120,
			renderCell: (params) => (
				<Typography variant="body2" color="text.secondary">
					{params.value}
				</Typography>
			),
		},
		{
			field: ' ',
			flex: 1,
			minWidth: 120,
			renderCell: (params) => (
				<ButtonCustom
					variant="outlined"
					onClick={params.row.viewDetails}
					size="sm"
				>
					See Details
				</ButtonCustom>
			),
		},
	]

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						hideFooter={true}
						rows={rows}
						columns={columns}
						height="320px"
						checkboxSelection={false}
						sx={
							{
								// height: 'calc(100dvh - 200px)',
								// '@media (max-width: 768px)': {
								// 	height: 'calc(100dvh - 260px)',
								// },
							}
						}
					/>
				</Box>
			</Box>
		</div>
	)
}
